/*****************************************************************************
 *   © Copyright 2021   Quantitative Software Management, Inc.               *
 *              --  All rights reserved.  --                                 *
 *   Unpublished -- rights reserved under the Copyright Laws                 *
 *   of the United States.                                                   *
 *                                                                           *
 *   This computer software is protected by trade secret, copyright law,     *
 *   and international treaties and contains proprietary and confidential    *
 *   trade secrets of Quantitative Software Management, Inc.  Unauthorized   *
 *   use, reproduction, or distribution of this program or any portion of    *
 *   it will result in severe civil or criminal penalties and will be        *
 *   prosecuted to the full extent of the law.                               *
 *                                                                           *
 *   Use, duplication, or disclosure by the Government is subject to         *
 *   restrictions as set forth in                                            *
 *      (i) a license agreement incorporated in the contract,                *
 *      (ii) the definition of "restricted rights" in paragraph (c)(1)(ii)   *
 *           of DFARS 252.227-7013 (1988), and                               *
 *      (iii) the definition of "restricted rights" in paragraph (a) of      *
 *            FAR 52.227-14, Alt III (Jun 1987) or                           *
 *      (iv) FAR 52.227-19 (Jun 1987), as applicable.                        *
 *   For purposes of the FAR, this software shall be deemed to               *
 *   be "unpublished" and licensed with disclosure prohibitions.             *
 *   Contractor/Manufacturer is   Quantitative Software Management, Inc.     *
 *                                                                           *
 *****************************************************************************/

import { CommonModule, DatePipe } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';

import { DialogModule } from '@progress/kendo-angular-dialog';
import { ContextMenuModule, MenuModule } from '@progress/kendo-angular-menu';
import { NotificationModule } from '@progress/kendo-angular-notification';

import { AppComponent } from './app.component';
import { ErrorComponent } from './error/error.component';
import { ErrorHandlerModule } from './error/error.module';
import { ErrorData } from './Models/errordata';
import { NotifierComponent } from './notifier/notifier.component';
import { RedirectToLoginComponent } from './redirect-to-login/redirect-to-login.component';
import { ErrorService } from './services/Error.Service';
import { EmbedPageComponent } from './views/embed-page/embed-page.component';
import { DashboardManagement } from './views/dashboard/management/dashboard-management.component';
import { SyncGuardHelper } from './services/sync-guard-helper.guard';
import { AuthorizeGuard } from './services/Authorize.Guard';
import { ErrorInterceptor } from './services/HTTPInterceptors/Error.Interceptor';
import { WebWakeupInterceptor } from './services/HTTPInterceptors/WebWakeup.Interceptor';

@NgModule({
  declarations: [
    AppComponent,
    RedirectToLoginComponent,
    ErrorComponent,
    NotifierComponent,
    EmbedPageComponent
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    CommonModule,
    ContextMenuModule,
    DialogModule,
    ErrorHandlerModule,
    FormsModule,
    HttpClientModule,
    MenuModule,
    NotificationModule,
    ReactiveFormsModule,
    RouterModule.forRoot([
      { path: 'app-notifier', component: NotifierComponent },
      { path: 'login', component: RedirectToLoginComponent },
      { path: 'error', component: ErrorComponent },
      { path: 'project', loadChildren: () => import('./views/project-view/project-view.module').then(m => m.ProjectViewModule) },
      { path: 'template', loadChildren: () => import('./views/template-view/template-view.module').then(m => m.TemplateViewModule) },
      { path: 'portfolio', loadChildren: () => import('./views/portfolio-view/portfolio-view.module').then(m => m.PortfolioViewModule) },
      { path: 'dashboard-management', component: DashboardManagement, canActivate: [SyncGuardHelper], data: { syncGuards: [AuthorizeGuard] } },
     { path: 'page', component: EmbedPageComponent },
      { path: '**', component: EmbedPageComponent }
    ])
  ],
  providers: [
    ErrorService,
    NotifierComponent,
    ErrorData,
    DatePipe,
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: WebWakeupInterceptor, multi: true }
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule {
}
